var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "footer-link-column-2 footer-link-column caption"
  }, [_c('div', {
    staticClass: "column-header"
  }, [_vm._m(0), _c('div', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.$t('footer.links')))])]), _c('div', {
    staticClass: "info-row",
    on: {
      "click": function ($event) {
        return _vm.$emit('openPopup', 'ARRIVAL');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.arrival')))]), _c('div', {
    staticClass: "info-row",
    on: {
      "click": function ($event) {
        return _vm.$emit('openPopup', 'MEDIA');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.media')))]), _c('div', {
    staticClass: "info-row",
    on: {
      "click": function ($event) {
        return _vm.$emit('openPopup', 'JOBS');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.jobs')))])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/arrow-right-black-extended.svg"),
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }